/**
 * Nombres de canal para mostrar.
 *
 * Módulo sin JSX para poder probarlo con el ejecutor de tests de Node. Un
 * canal desconocido se muestra tal cual: el catálogo lo define cada cliente al
 * instrumentar, así que la lista de acá es una cortesía, no una restricción.
 */

const ETIQUETAS: Record<string, string> = {
  web: 'Web',
  app_mobile: 'App Mobile',
  sucursal: 'Sucursal',
  call_center: 'Call Center',
  backend: 'Backend',
  desconocido: 'Sin canal',
};

export function etiquetaDeCanal(canal: string): string {
  if (!canal) return ETIQUETAS['desconocido'] as string;
  return ETIQUETAS[canal] ?? canal;
}

/**
 * El criterio de orden, aparte de la funcion que ordena.
 *
 * Se expone suelto porque el catalogo dejo de ser una lista de nombres: ahora
 * cada canal viene con si tuvo trafico, y ordenar objetos con el mismo
 * criterio no deberia obligar a duplicarlo.
 */
export function compararCanales(a: string, b: string): number {
  const prioridad = ['web', 'app_mobile', 'sucursal', 'call_center'];
  const ia = prioridad.indexOf(a);
  const ib = prioridad.indexOf(b);
  if (ia !== -1 || ib !== -1) return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
  return a.localeCompare(b, 'es');
}
